import React, { useEffect, useRef, useState } from "react"
import { useSelector } from "react-redux"
import { Row } from "reactstrap"

const Widgets = ({ widgets, marginTop, marginBottom }) => {
  const scrollRef = useRef(null)
  const [canScrollLeft, setCanScrollLeft] = useState(false)
  const [canScrollRight, setCanScrollRight] = useState(false)

  const { showWidgets } = useSelector(state => ({
    showWidgets: state.appSettings.showWidgets,
  }))

  useEffect(() => {
    if (widgets.length == 0) return

    const el = scrollRef.current
    if (!el) return

    updateScrollButtons()
    el.addEventListener("scroll", updateScrollButtons)
    return () => el.removeEventListener("scroll", updateScrollButtons)
  }, [widgets])

  const updateScrollButtons = () => {
    const el = scrollRef.current
    if (!el) return
    setCanScrollLeft(el.scrollLeft > 0)
    setCanScrollRight(
      parseInt(el.scrollLeft + el.clientWidth) < parseInt(el.scrollWidth) - 1
    )
  }

  const scrollToLeft = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollLeft = 0
    }
  }

  const scrollToRight = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollLeft = scrollRef.current.scrollWidth
    }
  }

  return (
    <React.Fragment>
      <div
        className="d-flex-row ai-center justify-content-between"
        style={{ gap: "5px" }}
      >
        {canScrollLeft && (
          <i
            className="fas fa-chevron-left"
            style={{ fontSize: "20px", cursor: "pointer" }}
            onClick={() => scrollToLeft()}
          />
        )}
        {/* {canScrollLeft && <button onClick={() => scrollToLeft()}>{"<"}</button>} */}
        <div
          ref={scrollRef}
          className="mb-3 scrollable-hidden-scrollbar"
          style={{
            marginTop: marginTop || "0px",
            marginBottom: marginBottom || "0px",
            // height: "110px",
            overflow: "auto",
          }}
        >
          {widgets.length > 0 && showWidgets && (
            <div className="widget-container">
              {widgets.map((w, idx) => RenderWidget(w, idx))}
            </div>
          )}
        </div>
        {canScrollRight && (
          <i
            className="fas fa-chevron-right"
            style={{ fontSize: "20px", cursor: "pointer" }}
            onClick={() => scrollToRight()}
          />
        )}
      </div>
    </React.Fragment>
  )
}

export const RenderWidget = (widget, idx) => {
  return (
    <div
      className="widgCard"
      key={idx}
      style={{
        minHeight:
          widget.height !== null && widget.height !== ""
            ? widget.height
            : "initial",
      }}
    >
      <div
        dangerouslySetInnerHTML={{
          __html: widget.title,
        }}
      ></div>
      <div style={{ display: "flex", flexDirection: "row" }}>
        <div
          style={{ verticalAlign: "top", paddingTop: "0px" }}
          dangerouslySetInnerHTML={{
            __html: widget.main,
          }}
        ></div>
        <div
          style={{ marginLeft: "10px" }}
          dangerouslySetInnerHTML={{
            __html: widget.secondary,
          }}
        ></div>
      </div>
      <div
        dangerouslySetInnerHTML={{
          __html: widget.footer,
        }}
      ></div>
    </div>
  )
}

export default Widgets
